module.exports = __webpack_public_path__ + "img/desktop_cover_sag.345372a8.png";